var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"habit-small-action"},[_c('explanation',{attrs:{"caption":"小さな行動","description":"苦にならない最小単位の行動を設定してください。"}}),_c('input-small-action'),_c('button-set-small-action')],1)}
var staticRenderFns = []

export { render, staticRenderFns }